/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Grid,
  Radio,
  FormControlLabel,
  FormControl,
  RadioGroup,
  TextField,
  Button,
} from '@material-ui/core';
import _ from 'lodash';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  getDrugsTherapeuticClassReport,
  getDrugsTherapeuticClassProccess,
  setSearchInput,
  dispatchErrorMsgNDCDetail,
  getDrugsTherapeuticClass,
  dispatchDrugsTherapeuticClassProccess,
  dispatchDrugsTherapeuticClassReport,
} from '../Store/Actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  autoFormateDate,
  tabHighLigther,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import {
  REBATE_SELECT,
  ERRORMESSAGE_SELECT_CLASS_VALUE,
  QUARTER_VALUE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import { DrugsTherapeuticClassGrid } from './TableHead';
import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  handleScrollToEvent,
  lowerCaseAllWordsExceptFirstLetters,
  upperCaseFirstLetter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const ReqDrugsTherapeuticClass = (props) => {
  const dispatch = useDispatch();
  const viewClaimDetailButton = 'Search';
  const gridRef = useRef();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramList: rebateProgramListData,
    fromDateValue,
    errorMsgPerDisRes: getErrorMsg,
    selectedSearchType,
    selectedNDC,
    ndcLeftTableData: ndcLeftTableDataArr,
    labelerSelectedRow: labelerSelectedRowValue,
    selectedClass,
    rebateProgramNameValue,
  } = useSelector((state) => state?.sharedState?.DrugsTherapeuticClassReducer);

  const resultTherapeuticClassList = useSelector(
    (state) =>
      state?.sharedState?.DrugsTherapeuticClassReducer?.therapeuticClassList
  );
  const resultTherapeuticClassProccess = useSelector(
    (state) =>
      state?.sharedState?.DrugsTherapeuticClassReducer?.proccessSearchResult
  );
  const resultTherapeuticClassReport = useSelector(
    (state) =>
      state?.sharedState?.DrugsTherapeuticClassReducer?.reportSearchResult
  );

  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.DrugsTherapeuticClassReducer
        ?.performDisputeResolutionObj
  );

  // get error msg for NDC
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = getErrorMsg?.searchScreenErrors
        ? getErrorMsg?.searchScreenErrors
        : [];
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        dispatchErrorMsgNDCDetail({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);
  // const [searchTypeRadioList] = React.useState([
  //   { name: 'NDC', value: 'NDC' },
  //   { name: 'Name', value: 'Name' },
  //   { name: 'Labeler', value: 'Labeler' },
  // ]);
  const [searchType, setSearchType] = React.useState(
    selectedSearchType
    // userDefaults?.defNdcSelectModeCd
    //   ? userDefaults?.defNdcSelectModeCd === 'NDC'
    //     ? 'NDC'
    //     : upperCaseFirstLetter(
    //         lowerCaseAllWordsExceptFirstLetters(
    //           userDefaults?.defNdcSelectModeCd
    //         )
    //       )
    //   : 'N'
  );
  const [selectList, setSelectList] = React.useState([]);
  const [selectedValue, setselectedValue] = React.useState(selectedClass);
  const [selectedRows, setSelectedRows] = React.useState([]);

  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [errorList, setErrorList] = React.useState(errors);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [selectedClassValue, setSelectedClassValue] = React.useState([]);
  const [therapeuticClassList, setTherapeuticClassList] = React.useState([
    resultTherapeuticClassList,
  ]);

  // variable deceleration for search type component
  const searchCompObj = requestCurrentDisData?.state?.searchTypeState;
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    labelerSelectedRowValue
  );

  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = React.useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = React.useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] =
    React.useState(ndcLeftTableDataArr);
  const [ndcRightTableData, setNdcRightTableData] = React.useState(selectedNDC);
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );

  const errorMessagesOfSearchTypeComp =
    getErrorMsg?.searchScreenErrors?.length > 0
      ? _.filter(
          getErrorMsg?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );

  // setErrors

  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  // setList Rebate program
  React.useEffect(() => {
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  }, [rebateProgramListData]);

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // on scroll default top level

  React.useEffect(() => {
    setselectedValue(selectedClass);
  }, [selectedClass]);

  // After each time once plantype changes rebateprogram list get updated using this API call
  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };
  React.useEffect(() => {
    handleScrollToEvent();
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  // Therapeutic class Grid From API
  React.useEffect(() => {
    setTherapeuticClassList(resultTherapeuticClassList);
  }, [resultTherapeuticClassList]);

  // API Call
  React.useEffect(() => {
    dispatch(
      getDrugsTherapeuticClass({
        codeDomainList: ['SPEC_THERA_CLASS_CD'],
      })
    );
  }, []);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/drugsTherapeuticClass', true);
    } else {
      tabHighLigther('/drugsTherapeuticClass', false);
    }
  }, [JSON.stringify(errorList)]);

  // function to validate Quarter
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let allErrors = errorList;
    let fromError = [];
    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      fromError = validateQuarter(value, 'fromDate', true);
      allErrors = allErrors.filter((error) => error.field !== 'fromDate');
      allErrors = [...allErrors, ...fromError];
    }
    setErrorList(allErrors);
  };

  // Grid functionality for selected code
  const [numberOfSelectedCodeRows, setNumberOfSelectedCodeRows] =
    React.useState(0);
  const onSelectionCodeChanged = (e, isAllChecked) => {
    const selectedCodeRows = e.api.getSelectedRows();
    setNumberOfSelectedCodeRows(e.api.getSelectedRows().length);

    if (
      selectedCodeRows.length === therapeuticClassList.length ||
      selectedCodeRows.length === 0
    ) {
    } else {
      const temp1 = [];
      const selectedCodeMenuName = [];
      for (let i = 0; i < selectedCodeRows.length; i++) {
        temp1.push({
          codeValue: selectedCodeRows[i].codeValuetemp,
        });
      }
      selectedCodeMenuName.sort();

      setSelectedRows(selectedCodeRows);
      let allErrors = getErrorMsg?.searchScreenErrors || [];
      allErrors = allErrors.filter((item) => item.field != 'noCodeSelected');
      // const unique = [...new Set(localErr)];
      allErrors = [...allErrors];
    }
  };

  const getSelectedCodeRowData = () => {
    const selectedCodeData = this.gridApi.getSelectedCodeRows();
    return selectedCodeData;
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen

  const handleViewDetailFunction = async (data) => {
    let allErrors = [];

    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    if (!fromDate) {
      allErrors =
        allErrors && allErrors?.filter((item) => item.field !== 'fromDate');
      allErrors.push({
        field: 'fromDate',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    const fromError = validateQuarter(fromDate, 'fromDate', true);
    allErrors = allErrors.filter((error) => error.field !== 'fromDate');

    const cRows =
      selectedValue === 'ALL' ? therapeuticClassList : selectedRows || [];
    if (cRows.length === 0) {
      allErrors.push({
        field: 'noCodeSelected',
        errorType: 'selectedCodeRequired',
        message: ERRORMESSAGE_SELECT_CLASS_VALUE,
      });
    }

    allErrors = [...allErrors, ...fromError];

    setErrorList(allErrors);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgramName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgramName = `${rebateProgramName?.rebateProgramCd} - ${
      rebateProgramName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        fromDateValue: fromDate,
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramNameValue,
        selectedSearchType: searchType,
        selectedClass: selectedValue,
        selectedClassValue:
          selectedValue === 'ALL'
            ? 'ALL'
            : selectedRows.map((item) => item?.codeValueID?.codeValue),
        data,
        labelerTableData,
        selectedNDC: data,
        ndcLeftTableData,
        labelerSelectedRow,
        rebateProgramName,
        displayObj: {
          rebateProgramName,
          rebateProgramValue: rebateProgram,
          fromDateValue: fromDate,
          rebateProgramList: rebateProgramListData,
          selectedClassValue:
            selectedValue === 'ALL'
              ? 'ALL'
              : selectedRows.map((item) => item?.codeValueID?.codeValue),
        },
      })
    );
    if (allErrors.length > 0 || data.length === 0) {
      if (allErrors.length > 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      return;
    }
    if (allErrors.length === 0) {
      setSearchClicked(true);
      dispatch(dispatchDrugsTherapeuticClassProccess([]));
      dispatch(
        getDrugsTherapeuticClassProccess({
          rebateProgramCd: rebateProgram,
          quarter: fromDate,
          specTheraClassCd:
            selectedValue === 'ALL'
              ? ['ALL']
              : selectedRows?.map((item) => item?.codeValueID?.codeValue),
          drugSeqNum: data?.map((item) => item?.drugSeqNum),
        })
      );
      dispatch(dispatchDrugsTherapeuticClassReport([]));
      dispatch(
        getDrugsTherapeuticClassReport({
          rebateProgramCd: rebateProgram,
          quarter: fromDate,
          specTheraClassCd:
            selectedValue === 'ALL'
              ? ['ALL']
              : selectedRows?.map((item) => item?.codeValueID?.codeValue),
          drugSeqNum: data?.map((item) => item?.drugSeqNum),
        })
      );
    }
  };
  if (
    isSearchClicked &&
    resultTherapeuticClassReport &&
    resultTherapeuticClassReport?.length > 0
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayDrugsTherapeuticClass',
      value: 'Display Drugs Therapeutic Class',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayDrugsTherapeuticClass',
    });
    dispatch(clearReduxForFilterAndSort('/displayDrugsTherapeuticClass'));
  }

  // For No Data validation for auto Scroll
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && errorList?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errorList]);
  const errorMessages = [...new Set(errorList?.map((obj) => obj.message))];
      
  //remove no data error msg 
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [planType, rebateProgram, fullScreenView, fromDate, selectedValue, searchType ]);

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <CustomSeparator
          parent1="State Reports"
          parent2="Drug Therapeutic Class"
        />
      )}
      <DisplayErrorMessages errorMessages={[...errorMessages].map((l) => l)} />

      <div className="tab-body" />

      <div className="row">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            data-testid="Interest-override-plan-type"
            id="filter-plan-by-radio-btn-action"
            labelName="Plan Type"
            required
            optionList={radioList || []}
            defaultValue={planType}
            filterAction={(value) => {
              setPlanType(value);
              setRebateProgram('-1');
              const errors = errorList.filter(
                (error) => error.field !== 'rebateProgram'
              );
              setErrorList([...errors]);
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-4">
          <>
            <Fieldset label="Rebate Program" required>
              <div style={{ marginTop: 18 }}>
                <SelectBoxComponent
                  data-testid="Interest-override-rebate-program"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Rebate Program"
                  required
                  select
                  selectOne
                  optionList={selectList || []}
                  defaultValue={rebateProgram}
                  filterAction={(value) => {
                    setRebateProgram(value);
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  isError={
                    errorList.find((error) => error.field === 'rebateProgram')
                      ?.message
                  }
                />
              </div>
            </Fieldset>
          </>
        </div>
        <div className="col-4">
          <Fieldset label="Quarter: " required>
            <div className="form-wrapper p-0 mt-n3">
              <div className="mui-custom-form input-md field-xl">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Quarter"
                      id="Quarter"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      required
                      name="From"
                      value={fromDate}
                      error={
                        errorList.filter((error) => error.field === 'fromDate')
                          ?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      data-testid="interest-override-from-date"
                      helperText={
                        errorList.find((error) => error.field === 'fromDate')
                          ?.message
                      }
                      className="mandate-fields frr-display-hidden-label"
                      onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                      onChange={(e) => {
                        setFromDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) => error.field !== 'fromDate'
                          ),
                        ]);
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-4 frr-two-col-radio" style={{ paddingTop: '10px' }}>
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Select Therapeutic Class
            </legend>
            <div className="form-wrapper p-0">
              <div className="mui-custom-form input-md field-xl">
                <div className="sub-radio no-margin">
                  <FormControl>
                    <RadioGroup row name="Report Type" value={selectedValue}>
                      <FormControlLabel
                        value="ALL"
                        control={<Radio />}
                        label="All"
                        data-testid="interest-override-rad-btn"
                        name="ALL"
                        onChange={(e) => {
                          setselectedValue(e.target.value);
                          setErrorList([
                            ...errorList.filter(
                              (error) => error.field !== 'noCodeSelected'
                            ),
                          ]);
                        }}
                      />
                      <FormControlLabel
                        value="Selected"
                        control={<Radio />}
                        label="Selected"
                        data-testid="interest-override-rad-btn1"
                        onChange={(e) => {
                          setselectedValue(e.target.value);
                        }}
                        name="Selected"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-sm-12">
          <SearchTypeComponent
            id="reportsNDC"
            data-testid="claim-audit-select-Ndc-Component"
            viewDetailButtonName={viewClaimDetailButton}
            searchType={searchType}
            setSearchType={setSearchType}
            getErrorsFromSearchTypeComponent={getErrorsFromSearchTypeComponent}
            errorMsgFromSearchType={errorMsgFromSearchType}
            setLabelerFullScreen={setLabelerFullScreen}
            labelerFullScreen={labelerFullScreen}
            setNdcLeftFullScreen={setNdcLeftFullScreen}
            ndcLeftFullScreen={ndcLeftFullScreen}
            setNdcRightFullScreen={setNdcRightFullScreen}
            ndcRightFullScreen={ndcRightFullScreen}
            handleViewDetailFunction={handleViewDetailFunction}
            setlabelerSelectedRow={setlabelerSelectedRow}
            labelerSelectedRow={labelerSelectedRow}
            setNdcLeftSelectedRows={setNdcLeftSelectedRows}
            ndcLeftSelectedRows={ndcLeftSelectedRows}
            setNdcRightSelectedRows={setNdcRightSelectedRows}
            ndcRightSelectedRows={ndcRightSelectedRows}
            setlabelerTableData={setlabelerTableData}
            labelerTableData={labelerTableData}
            setNdcLeftTableData={setNdcLeftTableData}
            ndcLeftTableData={ndcLeftTableData}
            setNdcRightTableData={setNdcRightTableData}
            ndcRightTableData={ndcRightTableData}
            setNdcSearchVal={setNdcSearchVal}
            ndcSearchVal={ndcSearchVal}
            setNdcNameSearchVal={setNdcNameSearchVal}
            ndcNameSearchVal={ndcNameSearchVal}
            iconName="search"
          />
        </div>
      </div>

      {selectedValue == 'Selected' && (
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGrid
            onSelectionChanged={onSelectionCodeChanged}
            getSelectedRowData={getSelectedCodeRowData}
            ref={gridRef}
            data-testid="onEditingStopped"
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={therapeuticClassList}
            columnDefs={DrugsTherapeuticClassGrid}
            rowSelection="multiple"
            rowMultiSelectWithClick
            exportFile
            animateRows
            sideBar={false}
            fileName="Drugs Therapeutic class"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            hideColumnsInPdf
            onCellFocused={onCellFocused}
          />
        </div>
      )}
    </div>
  );
};

export default ReqDrugsTherapeuticClass;
